import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const PhotoGuidelines = injectIntl(({ intl }) =>
  <article className="card">
    <header>
      <h2>
        <FormattedMessage {...messages.cropfaceDescription} />
      </h2>
    </header>
    <section>
      <figure>
        <img src="/assets/images/wellness/crop_guide.png" alt="Crop Guide" />
      </figure>
      <p>
        <FormattedMessage {...messages.drawBoxDescription} />
      </p>
    </section>
  </article>
);

export default PhotoGuidelines;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/cropGuidelines.jsx